import React from "react";
import { Header } from '../../../Components/Layout/Header.jsx'
import { ObavijestiCasino } from '../../../Components/Layout/ObavijestiCasino.jsx'
import { MetaTags } from '../../../Components/Layout/MetaTags.jsx'
import { FaqBanner } from './FaqBanner.jsx'
import { ReCaptcha } from '../../../Components/Shared/ReCaptcha.jsx'

export class Faq extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            captchaResetKey: new Date(),
            formSuccess: false,
            ime: '',
            nadimak: '',
            email: '',
            kategorija: 'registracija',
            poruka: '',
            captchaKey: '',
            faq: [
                {
                    id: 1,
                    kategorijaID: 1,
                    isActive: true,
                    visible: true,
                    pitanje: 'Kako se mogu registrirati?',
                    odgovor:
                        <ul>
                            <li>Ispuni stranicu za <a href="https://m.supersport.hr/registracija">registraciju</a> s točnim podacima, potvrdi svoju e-mail adresu i tvoj SuperSport račun je spreman!</li>
                        </ul>,
                },
                {
                    id: 2,
                    kategorijaID: 1,
                    isActive: false,
                    visible: true,
                    pitanje: 'Što ako poruka s aktivacijskim linkom nije stigla?',
                    odgovor:
                        <ul>
                            <li>Ako ti nije stigla e-mail poruka s aktivacijskim linkom u ‘Dolaznu poštu’, provjeri nalazi li se u pretincu ‘Neželjene pošte’</li>
                            <li>Ako se poruka ne nalazi ni u ‘Neželjenoj pošti’, javi nam se na: <a href="mailto:ssport@supersport.hr">ssport@supersport.hr</a></li>
                        </ul>,
                },
                {
                    id: 3,
                    kategorijaID: 1,
                    isActive: false,
                    visible: true,
                    pitanje: 'Što ako mi javlja grešku prilikom registracije?',
                    odgovor:
                        <ul>
                            <li>Odobrenje za internet klađenje dolazi sa servisa Hrvatske države za provjeru OIB-a.</li>
                            <li>Navedeni servis uspoređuje podatke upisane u formi na stranici za registraciju s podacima iz baza podataka OIB sustava</li>
                            <li>Ako podaci nisu identični, dobit ćeš obavijest o neispravnim podacima</li>
                            <li>Pokušaj ponovo ispuniti registracijsku formu i posebnu pažnju obrati na razmake i dijakritičke znakove (č, ć, š, ž)</li>
                            <li>Ako se greška ponavlja, provjeri svoje podatke na <a href="https://oib.oib.hr/SaznajOibWeb/fizickaOsoba.html" target="_blank">stranici za provjeru OIB-a.</a></li>
                            <li>Ukoliko na stranici za provjeru OIB-a uspješno upišeš sve podatke, utoliko ih trebaš kopirati i zalijepiti (copy-paste) u predviđena polja u formi za registraciju.</li>
                        </ul>,
                },
                {
                    id: 4,
                    kategorijaID: 1,
                    isActive: false,
                    visible: true,
                    pitanje: 'Naplaćuje li se registracija i korištenje stranice?',
                    odgovor:
                        <ul>
                            <li>Registracija i korištenje usluga stranice <a href="https://m.supersport.hr/">supersport.hr</a> je potpuno besplatno</li>
                            <li>Registracijom možeš čak i osvojiti bonuse, besplatne Casino vrtnje i druge pogodnosti</li>
                        </ul>,
                },
                {
                    id: 5,
                    kategorijaID: 1,
                    isActive: false,
                    visible: true,
                    pitanje: 'Kako mogu verificirati svoj račun?',
                    odgovor:
                        <ul>
                            <li>Za korištenje svih mogućnosti, tvoj račun mora biti verificiran</li>
                            <li>To znači da smo te uspješno identificirali kao vlasnika računa</li>
                            <li>Identifikaciju možeš odraditi u poslovnici ili putem videopoziva</li>
                        </ul>,
                },
                {
                    id: 6,
                    kategorijaID: 1,
                    isActive: false,
                    visible: true,
                    pitanje: 'Koji su uvjeti za postavljanje lozinke?',
                    odgovor:
                        <ul>
                            <li>Lozinka mora sadržavati najmanje deset znakova.</li>
                            <li>Obavezno koristi velika i mala slova, brojeve i posebne znakove (npr. !, & ili ?)</li>
                            <li>Pripazi da tvoja lozinka ne sadrži dijakritičke znakove (č, ć, š, ž)</li>
                            <li>Lozinka je poznata jedino tebi. Zaposlenici SuperSporta nemaju pristup tvojoj lozinci.</li>
                            <li>Kod kreiranja lozinke izbjegavaj koristiti podatke koji se lako povezuju s tobom (ime, datum rođenja i sl.)</li>
                            <li>Lozinku nikad ne dijeli s drugim osobama i ne zaboravi da prilikom kontakta, zaposlenici SuperSporta nikad neće pitati koja je tvoja lozinka</li>
                        </ul>,
                },
                {
                    id: 7,
                    kategorijaID: 2,
                    isActive: false,
                    visible: true,
                    pitanje: 'Što ako sam zaboravio lozinku?',
                    odgovor:
                        <ul>
                            <li>Na stranici prijave klikni na poveznicu <a href="https://m.supersport.hr/zaboravljena_lozinka">ZABORAVLJENA LOZINKA</a> i unesi e-mail adresu korištenu prilikom registracije</li>
                            <li>Kroz par minuta, na tu e-mail adresu stići će poruka s linkom za promjenu lozinke</li>
                            <li>Ako ti nije stigla e-mail poruka u ‘Dolaznu poštu’, provjeri nalazi li se u pretincu ‘Neželjena pošta’</li>
                            <li>Ako se poruka ne nalazi ni u ‘Neželjenoj pošti’, javi nam se na: <a href="mailto:ssport@supersport.hr">ssport@supersport.hr</a></li>
                        </ul>,
                },
                {
                    id: 8,
                    kategorijaID: 2,
                    isActive: false,
                    visible: true,
                    pitanje: 'Što ako sam zaboravio nadimak ili adresu elektronske pošte?',
                    odgovor:
                        <ul>
                            <li>Kontaktirajte našu podršku na <a href="mailto:ssport@supersport.hr">ssport@supersport.hr</a> ili ispuni formu na dnu stranice</li>
                        </ul>,
                },
                {
                    id: 9,
                    kategorijaID: 2,
                    isActive: false,
                    visible: true,
                    pitanje: 'Mogu li promjeniti nadimak, lozinku ili e-mail za prijavu?',
                    odgovor:
                        <ul>
                            <li>Lozinku i email adresu možeš promijeniti na svom korisničkom računu u rubrici  <a href="https://m.supersport.hr/racun#/podaci">‘Osobni podaci’</a></li>
                            <li>Za promjenu nadimka kontaktiraj našu podršku na <a href="mailto:ssport@supersport.hr">ssport@supersport.hr</a></li>
                        </ul>,
                },
                {
                    id: 10,
                    kategorijaID: 2,
                    isActive: false,
                    visible: true,
                    pitanje: 'Mogu li promijeniti adresu stanovanja i kontakt broj?',
                    odgovor:
                        <ul>
                            <li>Adresu i kontakt broj možete promijeniti na svom korisničkom računu u rubrici <a href="https://m.supersport.hr/racun#/podaci">‘Osobni podaci’</a></li>
                            <li>Broj mobitela upišite u formatu +3859xxxxxxx</li>
                        </ul>,
                },
                {
                    id: 11,
                    kategorijaID: 2,
                    isActive: false,
                    visible: true,
                    pitanje: 'Kako mogu ograničiti sudjelovanje u igri?',
                    odgovor:
                        <ul>
                            <li>Opcija <a href="https://casino.supersport.hr/racun/superpredah">SuperPredah</a> uvijek je dostupna i vidljiva unutar tvog casino računa pod korisničke opcije.</li>
                            <li>Odabirom SuperPredaha na raspolaganju su ti tri opcije: <br></br>
                                - ograničenje uloga u igru,<br></br>
                                - ograničenje gubitka,<br></br>
                                - predah od igre.
                            </li>
                            <li>Za svaku opciju biraš vremensko trajanje ograničenja ili pauze od igranja: 24 sata, 3 dana, 7 dana ili 30 dana.</li>
                            <li><b>Ograničenje uloga</b> - potrebno je upisati maksimalni iznos na koji želiš ograničiti uloge u igru. Tvoji ulozi u igru će se zbrajati do iznosa navedenog ograničenja. Kada dosegneš taj iznos, igra se automatski zaustavlja do isteka odabranog vremenskog ograničenja.</li>
                            <li><b>Ograničenje gubitka</b> - potrebno je upisati iznos na koji želiš ograničiti svoje gubitke u igri. Nakon što dosegneš taj iznos, daljnje igranje nije moguće do isteka odabranog vremenskog ograničenja.</li>
                        </ul>,
                },
                {
                    id: 12,
                    kategorijaID: 2,
                    isActive: false,
                    visible: true,
                    pitanje: 'Mogu li se Samoisključiti od igranja na određeno vrijeme?',
                    odgovor:
                        <ul>
                            <li>Opcija <a href="https://m.supersport.hr/racun#/samoiskljucenje">Samoisključenja</a> se nalazi unutar tvog računa pod korisničke opcije. </li>
                            <li>Ako se želiš trajno isključiti iz igre kod svih priređivača, to možeš napraviti tako da preuzmeš i ispuniš PDF obrazac  <a href="https://m.supersport.hr/s3/assets/Zahtjev-za-iskljucenje.pdf">Zahtjev za isključenjem iz sudjelovanja u igrama na sreću.</a></li>
                            <li>U tom obrascu upisuješ osobne podatke i biraš razdoblje isključenja tijekom kojeg nećeš moći igrati igre na sreću: 3 mjeseca, 6 mjeseci, 1 godina, 3 godine, 5 godina ili trajno isključenje. </li>
                            <li>Obrazac se predaje Hrvatskom zavodu za javno zdravstvo koji na temelju zaprimljenog zahtjeva blokira tvoj račun i onemogućuje ti daljnju igru. Više o samoisključenju možeš saznati  <a href="https://m.supersport.hr/s3/assets/RII_letak.pdf">ovdje</a></li>
                            <li>Ako tražiš privremenu pauzu od igre ili želiš postaviti ograničenje uloga ili gubitka, možeš aktivirati opciju <a href="https://m.supersport.hr/racun#/superpredah">SuperPredah</a>.</li>
                        </ul>,
                },
                {
                    id: 13,
                    kategorijaID: 2,
                    isActive: false,
                    visible: true,
                    pitanje: 'Kako zatvoriti svoj korisnički račun?',
                    odgovor:
                        <ul>
                            <li>Pošalji nam zahtjev s e-mail adrese korištene prilikom registracije i navedi svoj nadimak</li>
                            <li>Račun ćemo moći zatvoriti ako nemaš aktivnih listića, otvorenih transakcija i ako je tvoj raspoloživi iznos 0,00 €</li>
                        </ul>,
                },
                {
                    id: 14,
                    kategorijaID: 3,
                    isActive: false,
                    visible: true,
                    pitanje: 'Kako uplatiti sredstva na SuperSport račun?',
                    odgovor:
                        <>
                            <ul>
                                <li>Uplate možeš izvršiti:</li>
                            </ul>
                            <ol>
                                <li><b>1)</b> općom uplatnicom ili ebankingom</li>
                                <br />
                                <li>Za uplate unutar Republike Hrvatske upiši svoj <a href="https://m.supersport.hr/racun#/podaci">poziv na broj</a> na opću uplatnicu i u ebanking (polje MODEL ostavite prazno ili unesi 00 - ovisno o banci, a u polje POZIV NA BROJ unesi svoj). Pogledaj <a href="https://m.supersport.hr/racun#/uplata/Uplatnica">primjer ispravno popunjene opće ili ebanking uplatnice.</a></li>
                                <br />
                                <li><b>2)</b> u poslovnicama</li>
                                <br />
                                <li>Za uplatu u poslovnici blagajnici pokaži svoj <a href="https://m.supersport.hr/racun#/podaci">poziv na broj</a> i željeni iznos. Novac će odmah biti raspoloživ i vidljiv na internetskom računu. Ovakvom uplatom nemaš troškova transakcije, a minimalna uplata je 1,00 € (7,53 Kn).</li>
                                <br />
                                <li><b>3)</b> potvrdom o gotovinskoj ostavi iz kladomata</li>
                                <br />
                                <li>Uplati novce u kladomat, ispiši potvrdu o gotovinskoj ostavi i upisivanjem podataka s potvrde uplati iznos na svoj internetski račun. Uplaćena sredstva će odmah biti raspoloživa za igru.</li>
                                <br />
                                <li><b>4)</b> uplatom dobitka s listića iz poslovnice ili kladomata</li>
                                <br />
                                <li>Odigraj listić u poslovnici, a dobitak listića isplati na svoj internetski račun. Iznos dobitka će odmah biti raspoloživ, a možeš ga koristiti za daljnju igru ili ga u potpunosti isplatiti na svoj tekući račun ili u poslovnici.</li>
                                <br />
                                <li><b>5)</b> SuperSport bonom</li>
                                <br />
                                <li>Kupi SuperSport bon na kiosku Tiska i uplati ga na svoj internetski račun. Iznos kupljenog bona se umanjuje za troškove transakcije u visini 4%. Uplaćena sredstva će odmah biti raspoloživa za igru.</li>
                                <br />
                                <li><b>6)</b> Aircash aplikacijom</li>
                                <br />
                                <li>Koristi Aircash aplikaciju za trenutačnu uplatu sredstava na SuperSport račun. Uplaćivati možeš Visa, Maestro i Mastercard karticama ili gotovinom na bilo kojoj INA benzinskoj postaji. Kada koristiš karticu, dovoljno je samo prvi puta upisati podatke, a kasnije sredstva uplaćuješ jednim klikom. Preuzmi aplikaciju na <a href="https://aircash.eu/app/" target="_blank">https://aircash.eu/app/</a> ili saznaj više na <a href="https://aircash.eu/supersport-uplata" target="_blank">https://aircash.eu/supersport-uplata.</a></li>
                                <br />
                                <li><b>7)</b> A-bonom</li>
                                <br />
                                <li>Kupi Aircash a-bon na INA benzinskoj postaji, kioscima Tiska ili iNovina i uplati ga na svoj račun. Iznos kupljenog bona se umanjuje za troškove transakcije u visini 4%. Uplaćena sredstva će odmah biti raspoloživa za igru.</li>
                                <br />
                                <li><b>8)</b> Skrill računom</li>
                                <br />
                                <li>Skrill je jedan od najrasprostranjenijih i najsigurnijih načina on-line plaćanja podržan u preko 200 zemalja. Uplatu izvrši direktno putem Skrill računa ili putem podržanih kreditnih kartica - MasterCard, Diners, Visa, Visa Electron. Uplaćena sredstva će odmah biti raspoloživa za igru.</li>
                                <br />
                                <li><b>9)</b> karticama bankovnih računa</li>
                                <br />
                                <li>Uplatu možeš izvršiti putem kreditne/debitne kartice (Visa, MasterCard, Maestro, Diners, Discover) na supersport.hr ili putem ebankinga. Uplaćena sredstva će odmah biti raspoloživa za igru.</li>
                                <br />
                                <li><b>10)</b> Paysafecard</li>
                                <br />
                                <li>Ako za uplatu putem interneta ne želiš koristiti bankovni račun ili kreditnu karticu, radi dodatne sigurnosti na kiosku možeš kupiti paysafecard. Uz paysafecard plaćaš unosom korisničkog imena i lozinke za registrirane na my paysafecard. Iznos kupljenog bona se umanjuje za troškove transakcije u visini 6%.</li>
                                <br />
                                <li>Ako se trenutačno nalazite izvan Hrvatske, molimo Vas da se upoznate i ponašate u skladu s važećom regulativom područja u kojem se nalazite.</li>
                                <br />
                                <li><b>11)</b> Apple Pay</li>
                                <br />
                                <li>Uplatu možete izvršiti putem Apple Pay usluge na koju imate povezanu kreditnu/debitnu karticu (Visa, MasterCard, American Express, Discover, JCB). SuperSport će vam za raspoloživi iznos staviti upravo onaj koji pristigne na njegov račun.</li>
                                <br />
                                <li><b>12)</b> KEKS Pay aplikacijom</li>
                                <br />
                                <li>Uplatite sredstva na svoj SuperSport račun trenutno i bez naknade putem KEKS Pay aplikacije, svaki dan, 0–24, u samo nekoliko klikova. Uplaćeni iznos odmah će vam biti raspoloživ za igru.</li>
                                <br />
                            </ol>
                        </>,
                },
                {
                    id: 15,
                    kategorijaID: 3,
                    isActive: false,
                    visible: false,
                    pitanje: 'Kako uplatiti sredstva iz inozemstva?',
                    odgovor:
                        <>
                            <ol>
                                <li><b>1)</b> bankovnim transferom</li>
                                <br />
                                <li>Prilikom ispunjavanja podataka u polje svrha uplate upiši svoj poziv na broj. Supersport će na raspolaganje staviti onaj iznos koji pristigne na naš račun nakon odbitka svih bankovnih troškova. Svakako se raspitaj o visini troškova vezanih uz međunarodne transakcije (dosadašnja iskustva pokazuju iznos od 8 do 10 eura). Detalje za uplate iz inozemstva pogledaj ispod <a href="https://m.supersport.hr/racun#/uplata/Uplatnica">primjera ispravno popunjene opće ili ebanking uplatnice.</a></li>
                                <br />
                                <li><b>2)</b> Aircash aplikacijom</li>
                                <br />
                                <li>Aircash aplikacija omogućuje trenutačnu uplatu sredstava na SuperSport račun iz Hrvatske i inozemstva. Uplaćivati možeš Visa, Maestro i Mastercard karticama iz bilo koje države u svijetu. Preuzmi aplikaciju na <a href="https://aircash.eu/app/" target="_blank">https://aircash.eu/app/</a> ili saznaj više na <a href="https://aircash.eu/supersport-uplata" target="_blank">https://aircash.eu/supersport-uplata.</a></li>
                                <br />
                                <li><b>3)</b> Skrill računom i kreditnim karticama</li>
                                <br />
                                <li>Svakodnevno možeš uplatiti i preko Skrill (Moneybookers) računa ili putem podržanih kreditnih kartica - MasterCard, Diners, Visa, Visa Electron. Sredstva su odmah vidljiva na tvojem računu. Kod uplate preko supersport.hr u kojoj koristiš neku od kreditnih/debitnih kartica (Visa, MasterCard, Maestro, Diners, Discover) potrebno je imati karticu hrvatskih banaka.</li>
                                <br />
                                <li><b>4)</b> paysafecardom</li>
                                <br />
                                <li>Na račun možete uplatiti i paysafecard bonom kupljenim u Hrvatskoj ili u: Austriji, Bugarskoj, Cipru, Češkoj, Danskoj, Finskoj, Gibraltaru, Gruziji, Irskoj, Latviji, Luksemburgu, Mađarskoj, Malti, Poljskoj, Portugalu, Rumunjskoj, Slovačkoj, Sloveniji i Švicarskoj.</li>
                                <br />
                            </ol>
                        </>,
                },
                {
                    id: 16,
                    kategorijaID: 3,
                    isActive: false,
                    visible: true,
                    pitanje: 'Uplatio sam novce, ali na Casino računu mi piše nula – u čemu je problem.',
                    odgovor:
                        <ul>
                            <li>Inicijalnom uplatom sredstva se nalaze na glavnom SuperSport računu i potrebno ih je prebaciti na Casino račun</li>
                            <li>Prijenos se vrši na način da na Casino stranici odabereš: MOJ RAČUN – <a href="https://mcasino.supersport.hr/account">PRIJENOS NOVCA</a> - Prenesi novac na CASINO & POKER</li>
                            <li>Upiši iznos koji želiš prebaciti na Casino račun i s prebačenim sredstvima možeš igrati Casino & Poker</li>
                        </ul>,
                },
                {
                    id: 17,
                    kategorijaID: 3,
                    isActive: false,
                    visible: true,
                    pitanje: 'Uplatio sam novce, ali na poker računu mi piše nula – u čemu je problem.',
                    odgovor:
                        <ul>
                            <li>Inicijalnom uplatom sredstva se nalaze na glavnom SuperSport računu i potrebno ih je prebaciti na Casino račun</li>
                            <li>Prijenos se vrši na način da na Casino stranici odabereš: MOJ RAČUN – <a href="https://mcasino.supersport.hr/account">PRIJENOS NOVCA</a> – Prenesi novac na CASINO & POKER</li>
                            <li>Upiši iznos koji želiš prebaciti na Casino račun i s prebačenim sredstvima možeš igrati Casino & Poker</li>
                        </ul>,
                },
                {
                    id: 18,
                    kategorijaID: 4,
                    isActive: false,
                    visible: true,
                    pitanje: 'Kako prebaciti i podignuti sredstva s Casino računa?',
                    odgovor:
                        <ul>
                            <li>Ako želiš podignuti osvojeni dobitak, potrebno je imati verificiran račun, a zatim prebaciti sredstva na Glavni račun</li>
                            <li>Na Casino stranici odaberi: MOJ RAČUN – <a href="https://mcasino.supersport.hr/account">PRIJENOS NOVCA</a> – Prenesi novac na GLAVNI RAČUN</li>
                            <li>Upiši iznos koji želiš prebaciti na Glavni račun i sredstva se nakon potvrde prijenosa nalaze na tvom Glavnom računu</li>
                            <li>S Glavnog računa radiš <a href="https://m.supersport.hr/racun#/isplata">isplatu</a> na željeni način.</li>
                        </ul>,
                },
                {
                    id: 19,
                    kategorijaID: 4,
                    isActive: false,
                    visible: true,
                    pitanje: 'Na koji način mogu isplatiti osvojena sredstva?',
                    odgovor:
                        <ul>
                            <li>Isplatu radite kroz rubriku ISPLATA na Vašem Glavnom računu.</li>
                            <li>Odaberi željeni način <a href="https://m.supersport.hr/racun#/isplata">isplate</a> te slijedi korake:</li> <br />
                            <ul>
                                <br />
                                <li><a href="https://m.supersport.hr/racun#/uplata">TEKUĆI RAČUN</a></li>
                            </ul>
                            <ol>
                                <br />
                                <li>Upiši iznos isplate (min. isplata je 5,00 € (37,67 Kn)) i IBAN svog tekućeg računa (ne žiro niti devizni račun). Isplate se odobravaju radnih danima, dva puta dnevno oko 8 i 14 sati.
                                    Kada će sredstva biti provedena na tvoj tekući račun ovisi o bankama tj. o tome kada banke vrše transfere.
                                    Zahtjev za isplatu se ne može stornirati.</li>
                                <br />
                            </ol>
                            <ul>
                                <li><a href="https://m.supersport.hr/racun#/isplata/aircash">AIRCASH</a></li>
                            </ul>
                            <ol>
                                <br />
                                <li>Upiši iznos isplate, broj mobitela na koji je registriran AirCash račun te potvrdi zahtjev. Sustav će ponekad zatražiti dodatnu potvrdu isplate. U takvim situacijama će na tvoj e-mail biti poslan jednokratni verifikacijski kod koji trebaš upisati kod zahtjeva za isplatu.</li>
                                <li>Gdje podignuti sredstva s AirCasha, saznajte <a href="https://aircash.eu/poslovni-partneri/supersport/supersport-isplata/">OVDJE!</a></li>
                                <li>Ponekad je za neke transakcije potrebna dodatna provjera, no u pravilu sredstva budu odmah na tvom AirCash računu. </li>
                                <li>Zahtjev za isplatu se ne može stornirati.</li>
                                <br />
                            </ol>
                            <ul>
                                <li><a href="https://m.supersport.hr/racun#/isplata/aircash">POSLOVNICA</a></li>
                            </ul>
                            <ol>
                                <br />
                                <li>Upišei željeni iznos isplate, odaberi željenu adresu poslovnice te potvrdi isplatu. Prikaže Vam se broj i kôd isplate (broj i kod vidiš samo jednom pa ga zapiši), navedeni broj i kôd pokaži djelatnici u odabranoj poslovnici te će djelatnica napraviti isplatitu.</li>
                                <li>Sredstva možeš podići već sljedeći dan.</li>
                                <li>Isplatu u poslovnici možeš stornirati u svojim <a href="https://m.supersport.hr/racun#/transakcije">transkacijama</a>! Moguće je stornirati isplatu sve dok ne podigneš željena sredstva u poslovnici. U slučaju da sredstva ne podigneš u roku 4 dana, zahtjev ćemo automatski stornirati i vratiti ih na tvoj SuperSport račun.</li>
                                <br />
                            </ol>
                        </ul>,
                },
                {
                    id: 20,
                    kategorijaID: 5,
                    isActive: false,
                    visible: true,
                    pitanje: 'Gdje mogu vidjeti svoje obavijesti te Casino Bonuse i promocije?',
                    odgovor:
                        <ul>
                            <li>Svoje bonuse možeš vidjeti u svojoj rubrici <a href="https://mcasino.supersport.hr/pravila/faq/account/bonuses">BONUSI</a>!</li>
                            <li>Sve svoje obavijesti o Casino bonusima i promocijama nalaze se u rubrici <a href="https://mcasino.supersport.hr/racun/obavijesti">OBAVIJESTI</a>!</li>
                        </ul>,
                },
                {
                    id: 21,
                    kategorijaID: 5,
                    isActive: false,
                    visible: true,
                    pitanje: 'Gdje mogu vidjeti svoje odigrane igre i Casino transakcije?',
                    odgovor:
                        <ul>
                            <li>Svoje odigrane igre možeš pronaći u rubrici <a href="https://casino.supersport.hr/racun/OdigraneIgre">ODIGRANE IGRE</a>.</li>
                            <li>U navedenoj rubrici možeš tražiti odigrane igre i po datumu i po nazivu igre.</li>
                            <li>Svoje Casino transakcije možeš pronaći u rubrici <a href="https://casino.supersport.hr/racun/transakcije">TRANSAKCIJE</a>.</li>
                            <li>U navedenoj rubrici možeš tražiti transakcije po datumu i po vrsti transakcije (npr. Uplata u igru, Dobitak, Prijenos na Casino itd.)</li>
                        </ul>,
                },
                {
                    id: 22,
                    kategorijaID: 5,
                    isActive: false,
                    visible: true,
                    pitanje: 'Kako prihvatiti promociju Bonusa na uplatu (Casino deposit bonus)?',
                    odgovor:
                        <ul>
                            <li>Promocija se prihvaća u dva koraka.</li>
                            <li>Prvo prihvati ponudu u rubrici <a href="https://casino.supersport.hr/racun/bonusi">“Bonusi”</a> na svom Casino računu ( Casino račun – MOJ RAČUN – BONUSI)</li>
                            <li>Zatim je potrebno aktivirati promociju označavanjem pripadajuće “kućice” kod prijenosa sredstava na Casino račun.</li>
                            <li>Nakon što označiš da želiš navedenu promociju i završiš prijenos sredstava na Casino račun, ostvareni iznos bonusa se automatski dodijeli na tvoj Casino račun.</li>
                            <li>Uvijek obrati pažnju koliki je WR (uvjet odigravanja bonusa)</li>
                        </ul>,
                },
                {
                    id: 23,
                    kategorijaID: 5,
                    isActive: false,
                    visible: true,
                    pitanje: 'KAKO PREKINUTI BONUS PROMOCIJU TE ŠTO GUBIM?',
                    odgovor:
                        <ul>
                            <li>Bonus promociju možeš prekinuti u rubrici <a href="https://casino.supersport.hr/racun/bonusi">“Bonusi”</a> ( Casino račun – MOJ RAČUN – BONUSI)</li>
                            <li>Klikom na PREKINI prikaže se iznos koji gubiš i ako se slažeš s tim odaberi POTVRDI</li>
                            <li>Prekidom bonusa gubiš i osvojene dobitke u navedenoj promociji</li>
                            <li>Neodigrani iznos je vidljiv u rubrici <a href="https://casino.supersport.hr/racun/bonusi">BONUSI</a> na tvom računu (Casino račun – MOJ RAČUN – BONUSI)</li>
                        </ul>,
                },
                {
                    id: 24,
                    kategorijaID: 6,
                    isActive: false,
                    visible: true,
                    pitanje: 'Kako mogu iskoristiti besplatne vrtnje?',
                    odgovor:
                        <ul>
                            <li>Besplatne vrtnje je potrebno prihvatiti u rubrici <a href="https://casino.supersport.hr/racun/bonusi">BONUSI</a> na tvom računu (Casino račun – MOJ RAČUN – BONUSI)</li>
                            <li>Nakon toga samo pokreni igru za koju su bile namijenjene besplatne vrtnje</li>
                            <li>Uvijek obrati pažnju koliki je WR (uvjet odigravanja bonusa)</li>
                        </ul>,
                },
                {
                    id: 25,
                    kategorijaID: 6,
                    isActive: false,
                    visible: true,
                    pitanje: 'Što napraviti ako vrtnja ostane u igri?',
                    odgovor:
                        <ul>
                            <li>Savjetujemo korištenje Google Chrome, Microsoft Edge ili Mozilla Firefox preglednika za igranje naših igara</li>
                            <li>U slučaju da vrtnja ostane u igri, molimo te očisti predmemoriju tj. kolačiće na svom uređaju te ponovno pokušaj pokrenuti igru.</li>
                            <li>Ako navedeno nije pomoglo javi se našoj korisničkoj podršci na: <a href="mailto:ssport@supersport.hr">ssport@supersport.hr</a></li>
                        </ul>,
                },
                {
                    id: 26,
                    kategorijaID: 6,
                    isActive: false,
                    visible: true,
                    pitanje: 'Što je RTP?',
                    odgovor:
                        <ul>
                            <li>RTP (Return to player) je deklarirani postotak povrata igraču, tj. postotak svih uloga koji će igra/slot kroz osvojene dobitke vratiti igračima</li>
                            <li>RTP se izračunava tako da se ukupni dobitak od casino igara podijeli s ukupnim ulogom u te igre</li>
                            <li>Potrebno je uzeti u obzir da je iznos RTP-a za pojedinu igru iskazan kao prosjek na vrlo velik broj vrtnji (1.000.000 i više) pa po pojedinom igraču i u pojedinom periodu može značajno odstupati, a to odstupanje ovisi o varijanci same igre</li>
                            <li>Primjerice, ako igrate igre niske varijance koje u pravilu imaju veći broj manjih dobitaka, kratkoročni RTP će biti bliži prosječnom, dok kod igara visoke varijance kratkoročno RTP može značajno odstupati od prosjeka</li>
                            <li>Uobičajeni RTP na igrama se kreće od 95% do 98%</li>
                        </ul>,
                },
                {
                    id: 27,
                    kategorijaID: 6,
                    isActive: false,
                    visible: true,
                    pitanje: 'Što je varijanca ili volatilnost?',
                    odgovor:
                        <ul>
                            <li>Varijanca ili volatilnost je podatak koji nam govori koliko često igra isplaćuje dobitak</li>
                            <li>Uobičajeno se izražava ili brojevima od jedan do 10 ili stanjima (niska, umjerene, srednja visoka i vrlo visoka)</li>
                            <li>Varijancu je najjednostavnije objasniti primjerom. Uzmimo za primjer rulet, u ruletu ako igrate crveno i crno dobivat ćeš skoro svaku drugu vrtnju i to je igra niske volatilnosti, a ako npr. uzmemo kocku i kažemo da se kladimo na broj jedan dobit ćeš svaku šestu vrtnju što je igra umjerene volatilnosti, ako uzmemo rulet i uložimo na broj dobitak će biti osvojen svakih 36 puta i to je igra visoke varijance</li>
                            <li>Igre više varijance rjeđe isplaćuju dobitke, ali su oni onda veći nego u ostalim igrama</li>
                        </ul>,
                },
                {
                    id: 28,
                    kategorijaID: 6,
                    isActive: false,
                    visible: true,
                    pitanje: 'Kako instalirati SuperSport Casino aplikaciju?',
                    odgovor:
                        <ul>
                            <li>Naša aplikacija je podržana trenutačno samo na Android uređajima i možeš ju preuzeti <a href="https://mcasino.supersport.hr/download">OVDJE</a> </li>
                        </ul>,
                },
                {
                    id: 29,
                    kategorijaID: 6,
                    isActive: false,
                    visible: true,
                    pitanje: 'Je li sigurno igrati na SuperSport casinu?',
                    odgovor:
                        <ul>
                            <li>Svaki pružatelj usluga će tvrditi da je kod njega sigurno, međutim, mi u SuperSportu se trudimo da se ta sigurnost i potvrdi certifikatima neovisnih organizacija</li>
                            <li>Svaka pojedina igra ima certifikat izdan od strane nezavisnog laboratorija gdje je testiran RTP i kojim se potvrđuje sigurnost. Uz to, SuperSport za svaku igru provjerava s vanjskim laboratorijima kvalitetu integracije u sustav gdje se provjerava koliko je igra kvalitetno integrirana, a posebno se certificira komunikacija igre sa SuperSport sustavom.</li>
                            <li>Također, SuperSport je certificiran od strane neovisnih auditora za ISO 27001 kojim se potvrđuje da su podaci kod nas sigurni</li>
                        </ul>,
                },
                {
                    id: 30,
                    kategorijaID: 6,
                    isActive: false,
                    visible: true,
                    pitanje: 'Kada je nastao SuperSport?',
                    odgovor:
                        <ul>
                            <li>Supersport je jedna od najstarijih hrvatskih firmi koja se bavi igrama na sreću.</li>
                            <li>Osnovani smo 2000 godine od strane ekipe koja je odlučila sva svoja znanja prenijeti u stvaranje najboljeg i najsigurnijeg iskustva za svakog igrača kladionice i Casina.</li>
                            <li>Više detalja možeš otkriti <a href="https://casino.supersport.hr/pravila/o_tvrtki">OVDJE</a></li>
                        </ul>,
                },
                {
                    id: 31,
                    kategorijaID: 7,
                    isActive: false,
                    visible: true,
                    pitanje: 'Što znači oznaka 18+?',
                    odgovor:
                        <ul>
                            <li>Zabranjeno je sudjelovanje u igri osobama mlađima od 18 godina</li>
                            <li>SuperSport kladionica d.o.o. nudi zabavu prepunu izazova pa zahtijeva odgovorno ponašanje igrača</li>
                            <li>SuperSport je pouzdan partner jer temelji igru na fair playu i sigurnom klađenju</li>
                            <li>SuperSport te moli da u igri ne prelaziš granice svojih financijskih mogućnosti i igraš odgovorno</li>
                        </ul>,
                },
                {
                    id: 32,
                    kategorijaID: 7,
                    isActive: false,
                    visible: true,
                    pitanje: 'Koja su pravila odgovornog igranja igara na sreću?',
                    odgovor:
                        <>
                            <ul>
                                <li>U nastavku se nalaze pravila odgovornog sudjelovanja u igrama na sreću:</li>
                            </ul>
                            <ol>
                                <br />
                                <li>-   Sudjeluj u igrama na sreću samo i isključivo radi zabave.</li>
                                <br />
                                <li>-	Unaprijed jasno odredi limit novčanih sredstava koji možeš izdvojiti za sudjelovanje u igri i ne mijenjaj ga.</li>
                                <br />
                                <li>-	Novac koji izgubiš smatraj cijenom tvoje zabave, a svaki dobitak nagradom.</li>
                                <br />
                                <li>-	Unaprijed jasno odredi vremenski period koji želiš izdvojiti za sudjelovanje u igrama na sreću, a kada navedeno vrijeme istekne prekini s igrom bez obzira jesi li na dobitku ili gubitku u navedenom trenutku.</li>
                                <br />
                                <li>-	Prije upuštanja u igre na sreću budi svjestan činjenice da su izgledi za gubitak veći od izgleda za dobitak</li>
                                <br />
                                <li>-	Ne sudjeluj u igrama na sreću na kredit ili s posuđenim novcem</li>
                                <br />
                                <li>-	Ne dopusti da sudjelovanje u igrama na sreću negativno utječe na tvoj obiteljski, društveni i poslovni život</li>
                                <br />
                                <li>-	Izbjegavaj lov na izgubljeni novac jer će tvoji gubici time vjerojatno biti veći što se više trudite nadoknaditi izgubljeno.</li>
                                <br />
                                <li>-	Pravovremeno se informiraj o znakovima koji ukazuju na kompulzivno i prekomjerno sudjelovanje u igrama na sreću kako bi na vrijeme znao prestati i/ili zatražiti pomoć</li>
                                <br />
                            </ol>
                        </>
                },
                {
                    id: 33,
                    kategorijaID: 7,
                    isActive: false,
                    visible: true,
                    pitanje: 'Kome se obratiti za psihološku pomoć ako se igrom prelaze limiti vlastitih financijskih mogućnosti?',
                    odgovor:
                        <ul>
                            <li>Psihološku pomoć i savjetovanje možete zatražiti na besplatan broj telefona 0800 200 005 ili na sljedećim mjestima:
                                <br /><br />
                                PSIHIJATRIJSKA BOLNICA „SVETI IVAN“ ZAGREB<br />
                                Kontakt:<br />
                                Ambulanta<br />
                                tel.: 01 3430 102<br />
                                Voditelj:<br />
                                Davor Bodor, dr. med.<br />
                                specijalist psihijatar<br />
                                tel.: 01 3430 101 (ponedjeljak i srijeda 15–16h)<br />
                                email: davor.bodor@pbsvi.hr<br />

                                <a href="https://www.pbsvi.hr/dnevne-bolnice/dnevna-bolnica-za-ovisnost-o-kockanju-kocka/">https://www.pbsvi.hr/dnevne-bolnice/dnevna-bolnica-za-ovisnost-o-kockanju-kocka/</a><br />
                                <br />
                                CENTAR ZA PREVENCIJU OVISNOSTI<br />
                                Nastavni zavod za javno zdravstvo<br />
                                Kalvarija 8, Rijeka<br />
                                prof. psihologije Pino Tuftan<br />
                                tel.: 091 720 1053<br />
                                ANONIMNI KOCKARI SPLIT<br />
                                email: misternogambling@email.t-com.hr

                            </li>
                        </ul>,
                },
            ],
            faqKategorije: [
                {
                    id: 1,
                    title: 'Registracija',
                },
                {
                    id: 2,
                    title: 'Račun',
                },
                {
                    id: 3,
                    title: 'Uplate',
                },
                {
                    id: 4,
                    title: 'Isplate',
                },
                {
                    id: 5,
                    title: 'Promocije',
                },
                {
                    id: 6,
                    title: 'Ostalo',
                },
                {
                    id: 7,
                    title: 'Pomoć',
                },
            ],
            faqActive: null,
            faqKategorijeActiveIndex: 1,
            attachedFiles: [],
            attachedFileNames: [],
            attachedFilesBase64: [],
            uploadingFile: false,
            loading: false,
            validateIme: true,
            validateMail: true,
            validateNadimak: true,
            validatePoruka: true,
            validateCaptchaKey: true,
            emailWrongFormat: false,
            formError: false,
            formeErrorMessage: null,
            user: null,
            showInformacije: false,
        }

        this.updateCaptcha = this.updateCaptcha.bind(this);
        this.sendFromData = this.sendFromData.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.faqAttachmentPageModalRef = React.createRef();
        this.convertToBase64 = this.convertToBase64.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.loginFromOutside = this.loginFromOutside.bind(this);
        this.setData = this.setData.bind(this);
    }

    /**** LIFECYCLE METHODS *****/
    componentDidMount() {
        if (!casino.casinoConstants.igracSePromijenio)
            casino.casinoConstants.igracSePromijenio = [];

        //add callback method after login
        casino.casinoConstants.igracSePromijenio.push(this.loginFromOutside);

        let categoryFaqItems = this.state.faq.filter((item, i) => {
            if (item.kategorijaID != this.state.faqKategorijeActiveIndex)
                return null;
            return item;
        })

        this.setState({ faqActive: categoryFaqItems[0] ? categoryFaqItems[0] : null });

        this.setData();
    }
    /***************************/
    setData() {
        casino.repos.sessionRepo.get().then(result => {
            if (result.Igrac)
                this.setState({ user: result.Igrac });
        });
    }

    loginFromOutside(data) {
        this.setData();
    }

    sendFromData(event) {
        event.preventDefault();

        let newState = this.validateForm();

        if (!this.state.ime || !this.state.nadimak || !this.state.email || newState.emailWrongFormat || !this.state.kategorija || !this.state.poruka || !this.state.captchaKey) {
            this.setState(newState);
            return;
        }

        this.setState({ loading: true });

        const model = {
            ime: this.state.ime,
            nadimak: this.state.nadimak,
            email: this.state.email,
            kategorija: this.state.kategorija,
            poruka: this.state.poruka,
            captchaKey: this.state.captchaKey,
            attachedFiles: this.state.attachedFileNames
        };

        casino.repos.mailFormRepo.post(model).then((result) => {
            if (result.success) {
                this.setState({
                    formSuccess: true,
                    loading: false,
                    ime: '',
                    nadimak: '',
                    email: '',
                    kategorija: 'registracija',
                    poruka: '',
                    captchaKey: '',
                    attachedFiles: [],
                    attachedFileNames: []
                });
                setTimeout(() => { this.setState({ formSuccess: false }); }, 5000);
            } else {
                this.setState({ loading: false, formError: true, formeErrorMessage: result.message, formSuccess: false });
                setTimeout(() => { this.setState({ formError: false, formeErrorMessage: null }); }, 5000);
            }
        });
    }

    validateForm() {
        //Reset validation
        var newState = this.resetValidation();

        if (!this.state.ime)
            newState.validateIme = false;
        if (!this.state.email)
            newState.validateMail = false;
        if (this.state.email && !casino.utils.validateEmail(this.state.email))
            newState.emailWrongFormat = true;
        if (!this.state.nadimak)
            newState.validateNadimak = false;
        if (!this.state.poruka)
            newState.validatePoruka = false;
        if (!this.state.captchaKey)
            newState.validateCaptchaKey = false;

        return newState;
    }

    resetValidation() {
        return {
            validateIme: true,
            validateMail: true,
            validateNadimak: true,
            validatePoruka: true,
            emailWrongFormat: false,
            validateCaptchaKey: true,
        };
    }

    updateCaptcha(captcha = "") {
        this.setState({ captchaKey: captcha, validateCaptchaKey: true });
    }

    faqShowHide(index) {
        this.setState({
            faq: this.state.faq.map((item, idx) => idx !== index ? item : { ...item, isActive: !item.isActive })
        })
    }

    menuClick(index) {
        let categoryFaqItems = this.state.faq.filter((item, i) => {
            if (item.kategorijaID != index + 1)
                return null;
            return item;
        })

        this.setState({
            faqKategorijeActiveIndex: index + 1,
            faqActive: categoryFaqItems[0] ? categoryFaqItems[0] : null
        });
    }

    renderPitanje(item, index) {
        if (item.kategorijaID != this.state.faqKategorijeActiveIndex) {
            return;
        } else if (item.visible !== false) { // if we do not want to render a certain question
            return (
                <div key={"pitanje-" + index} className={"faq-item " + (item.isActive ? 'active' : '')}>
                    <div className="question-container" onClick={() => this.faqShowHide((item.id - 1))}>
                        <p className="question">{item.pitanje}</p>
                        <button className="arrow-faq"></button>
                    </div>
                    <div className="">
                        <ul className="answer">
                            <li>{item.odgovor}</li>
                        </ul>
                    </div>
                </div>
            )
        }
    }

    renderMenuItem(item, index) {
        return (
            <li key={"menu-" + index} className={"menu-item " + (item.id == this.state.faqKategorijeActiveIndex ? 'active' : '')} onClick={() => this.menuClick((item.id - 1))}>
                <a >
                    {item.title}
                </a>
            </li>
        )
    }

    renderInformacije() {
        return <div>
            <div className="faq-info">
                <div className="title">Tko sam ja?</div>
                <p>Bok, ja sam Superbot!</p>
                <p className="large">
                    Ekipa iz SuperSport-a me stvorila s jednom osnovnom zadaćom - da brinem o Vama.
                </p>
                <span className="img-character"></span>
                <p>
                    Još sam mlad i tek sam počeo učiti i molim Vas da imate obzira prema meni, a ja ću se truditi da brzo naučim.
                </p>
                <p> Kad naučim bit ću Vam uvijek dostupan, kao najbolji frend kojeg možete pitati sve što ne znate o bilo kojoj utakmici, paru, igri ili ponudi, no sada za početak Vam pripremam najčešća pitanja.. a ukoliko u njima ne nađete odgovor možete poslati upit meni i mojoj ljudskoj ekipi.</p>
            </div>
            {/*<button className="pitaj-bota-btn">Pitaj Superbota</button>*/}
        </div>
    }

    attachFile = (e) => {
        let file = e.target.files[0];
        let fileList = this.state.attachedFiles;
        let attachedFileNames = this.state.attachedFileNames;
        let fileTypes = ['image/png', 'image/jpeg', 'application/pdf', 'video/quicktime', 'video/mp4'];
        if (!file.name
            || fileList.filter(it => it.name == file.name).length > 0
            || fileTypes.filter(x => x == file.type).length == 0)
            return

        file.upload = true;

        fileList.push(file);
        this.convertToBase64(file, (fileObject) => {
            this.uploadFile(fileObject, (result) => {
                if (result.success) {
                    file.upload = false;
                    attachedFileNames.push(result.message);
                    this.setState({ attachedFileNames: attachedFileNames });
                }
            });
        });
        this.setState({ attachedFiles: fileList });
    }

    uploadFile(file, callback) {
        this.setState({ uploadingFile: true });
        casino.repos.fileUploadRepo.post(file).then((result) => {
            if (result.success)
                this.setState({ uploadingFile: false });
            callback(result);
        });
    }

    convertToBase64(file, callback) {
        let fileListBase64 = this.state.attachedFilesBase64;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            callback({ base64: reader.result, type: file.type, name: file.name });
        };
        reader.onerror = (error) => {
        };
    }

    removeFile(index) {
        let newArrayBase64 = this.state.attachedFilesBase64.filter((file, i) => i != index);
        let newArray = this.state.attachedFiles.filter((file, i) => i != index);
        let newAttachedFileNames = this.state.attachedFileNames.filter((fileName, i) => i != index);
        this.setState({ attachedFiles: newArray, attachedFilesBase64: newArrayBase64, attachedFileNames: newAttachedFileNames });
    }

    renderAttachedFiles() {
        return this.state.attachedFiles.map((file, i) =>
            <div key={"file" + i} className="document-name">
                <p className={((file.size / 1024) / 1024) >= 20.00 ? "document-file-error" : "document-file"}>{file.name}</p>
                <div className="document-right-side">
                    <span className={((file.size / 1024) / 1024) >= 20.00 ? "document-checkmark-error" : file.upload ? "document-loading" : "document-checkmark"} />
                    <p className={((file.size / 1024) / 1024) >= 20.00 ? "document-size-error" : "document-size"}>{((file.size / 1024) / 1024).toFixed(2) == 0.00 ? ((file.size / 1024) / 1024).toFixed(4) : ((file.size / 1024) / 1024).toFixed(2)}MB</p>
                    <p onClick={() => this.removeFile(i)} className="ukloni-dokument"></p>
                </div>
            </div>
        )
    }

    render() {
        return <div>
            <MetaTags title="Često postavljena pitanja | SuperSport Online Casino | SuperCasino" description="Registracija. Račun. Casino Igre. Uplate. Isplate. Casino Bonusi i Promocije. Besplatne vrtnje. Ostalo. Pomoć." />
            <Header key="header" {...this.state} {...this.props}></Header>

            <FaqBanner></FaqBanner>
            <div id="page-wrapper" className="white faq-wrapper">
                <div className="segment v2">
                    <button onClick={() => this.setState({ showInformacije: false })} className={'segment--btn ' + (!this.state.showInformacije ? 'selected' : '')}><span>Najčešća pitanja</span></button>
                    <button onClick={() => this.setState({ showInformacije: true })} className={'segment--btn ' + (this.state.showInformacije ? 'selected' : '')}><span>Informacije</span></button>
                </div>

                {/*Pitanja*/}
                {!this.state.showInformacije &&
                    <>
                        <ul className="faq-menu">
                            {this.state.faqKategorije && this.state.faqKategorije.map((item, index) => {
                                return this.renderMenuItem(item, index)
                            })}
                        </ul>
                        <div className="content-container">
                            {this.state.faq && this.state.faq.map((item, index) => {
                                return this.renderPitanje(item, index)
                            })}
                        </div>
                    </>}
                {/*Informacije*/}
                {this.state.showInformacije && <div className="faq-container maximum margin-center" >
                    {this.renderInformacije()}
                </div>}

                <div className="form-container">
                    {!this.state.formSuccess && !this.state.loading && !this.state.formError && <h1>Nisi našao odgovor? <span className="faq-red"> Kontaktiraj nas.</span></h1>}
                    {!this.state.formSuccess && <form onSubmit={this.sendFromData}>
                        <div className="faq-row">
                            <div className="row-form">
                                <p className="input-label">Ime {(!this.state.validateIme == '' ? '' : <span className="validation-text-error"> Obavezno polje!</span>)}</p>
                                <div className="input-container">
                                    <div className={"input-wrapper " + (this.state.validateIme == '' ? 'error' : '')}>
                                        <input className="input" type="text" value={this.state.ime} onChange={(e) => this.setState({ ime: e.target.value, validateIme: true })}></input>
                                    </div>
                                </div>
                                <p className="input-label">Nadimak {(!this.state.validateNadimak == '' ? '' : <span className="validation-text-error"> Obavezno polje!</span>)}</p>
                                <div className="input-container">
                                    <div className={"input-wrapper " + (this.state.validateNadimak == '' ? 'error' : '')}>
                                        <input className="input" type="text" value={this.state.nadimak} onChange={(e) => this.setState({ nadimak: e.target.value, validateNadimak: true })}></input>
                                    </div>
                                </div>
                                <div className="row-form">
                                    <p className="input-label">Mail{(this.state.validateMail == '' ? <span className="validation-text-error"> Obavezno polje!</span> : this.state.emailWrongFormat ? <span className="validation-text-error"> Polje je krivo popunjeno!</span> : '')}</p>
                                    <div className="input-container">
                                        <div className={"input-wrapper " + (this.state.validateMail == '' ? 'error' : '')}>
                                            <input className="input" type="text" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value, validateMail: true, emailWrongFormat: false })}></input>
                                        </div>
                                    </div>
                                </div>
                                <p className="input-label">Kategorija</p>
                                <div className="input-container">
                                    <div className="input-wrapper">
                                        <select name="kategorije-faq" className="kategorije-faq" value={this.state.kategorija} onChange={(e) => this.setState({ kategorija: e.target.value })}>
                                            <option value="registracija">Registracija</option>
                                            <option value="racun">Račun</option>
                                            <option value="uplate">Uplate</option>
                                            <option value="isplate">Isplate</option>
                                            <option value="promocije">Promocije</option>
                                            <option value="casino">Casino</option>
                                            <option value="kladionica">Kladionica</option>
                                            <option value="ostalo">Ostalo</option>
                                            <option value="pomoc">Pomoć</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="poruka-faq">
                            <p className="input-label">Poruka {(!this.state.validatePoruka == '' ? '' : <span className="validation-text-error"> Obavezno polje!</span>)}</p>
                            <div className="input-container">
                                <div className={"input-wrapper " + (this.state.validatePoruka == '' ? 'error' : '')}>
                                    <textarea className="input" placeholder="Upiši poruku ovdje..." value={this.state.poruka} onChange={(e) => this.setState({ poruka: e.target.value, validatePoruka: true })}></textarea>
                                </div>
                            </div>
                        </div>
                        {this.state.attachedFiles.filter(file => ((file.size / 1024) / 1024) >= 20.00).length > 1 ? <p className="error-message">Označeni dokumenti se neću poslati!</p> : this.state.attachedFiles.filter(file => ((file.size / 1024) / 1024) >= 20.00).length > 0 && <p className="error-message"> Dokument: {this.state.attachedFiles.filter(file => ((file.size / 1024) / 1024) >= 20.00)[0].name} se neće poslati</p>}
                        {this.state.attachedFiles.map(file => ((file.size / 1024) / 1024)).reduce((prev, curr) => prev + curr, 0) > 30 && <p className="error-message">Ukupna veličina priloženih datoteka je prevelika!</p>}
                        <p className="attachment-size">Max. dopuštena ukupna veličina dokumenata do  <b>20MB</b></p>
                        <p className="text-grey">Možete dodati dokument u formatu: .jpeg, .png, .pdf, .mp4 i .mov</p>
                        {this.state.attachedFiles.length > 0 && <div className="form-attachments">
                            <div className="attachments-documents">
                                {this.renderAttachedFiles()}
                            </div>
                        </div>}
                        <div className="form-buttons">
                            <div>
                                <label className="privitak-faq">
                                    <input className="privitak-hidden" type="file" onChange={(e) => this.attachFile(e)} /><span className="privitak-tekst">DODAJ PRIVITAK</span></label>
                                <button type="submit" className="posalji-privitak"
                                    disabled={(this.state.uploadingFile || (this.state.attachedFiles.map(file => ((file.size / 1024) / 1024)).reduce((prev, curr) => prev + curr, 0) > 30 ||
                                        this.state.attachedFiles.filter(file => ((file.size / 1024) / 1024) >= 20.00).length > 0) ? true : false)} >POŠALJI
                                </button>
                            </div>
                        </div>
                        <ReCaptcha className="captcha" key={this.state.captchaResetKey} updateCaptchaFn={this.updateCaptcha}></ReCaptcha>
                        {(this.state.validateCaptchaKey ? '' : <p className="captcha-error">Molimo ispunite verifikaciju!</p>)}
                    </form>}
                    {!this.state.formSuccess && this.state.loading && !this.state.formError && <div className="message-uploading">
                        <div className="spining-loader">
                        </div>
                        <div className="message">
                            {this.state.attachedFiles.length > 0 ? <p>Datoteke se učitavaju. <br />Molimo pričekajte...</p> : <p>Poruka se šalje. <br />Molimo pričekajte...</p>}
                        </div>
                    </div>}
                    {!this.state.formError && this.state.formSuccess && !this.state.loading && <div className="message-send">
                        <div className="circle-checkmark">
                        </div>
                        <div className="message">
                            <p><span className="green-text">Tvoj upit je uspješno poslan.</span><br />
                                Potruditi ćemo se da ti se povratno javimo u najkraćem <br />
                                mogućem roku.</p>
                        </div>
                    </div>}
                    {this.state.formError && !this.state.loading && !this.state.formSuccess && <div className="message-send">
                        <div className="circle-checkmark-error">
                        </div>
                        <div className="message">
                            <p><span className="red-text">Dogodila se greška.</span><br />{this.state.formeErrorMessage && <span className="error-message">{this.state.formeErrorMessage}</span>}</p>
                        </div>
                    </div>}
                </div>
            </div>
            <ObavijestiCasino {...this.props}></ObavijestiCasino>
        </div>
    }
}